export const flexFlatCategories = {
    'AddressIcon': '@/icons/flex-flat/address-book-icon.svg',
    'BackpackIcon': '@/icons/flex-flat/backpack.svg',
    'BallIcon': '@/icons/flex-flat/ball.svg',
    'BaseballIcon': '@/icons/flex-flat/baseball.svg',
    'BicycleBikeIcon': '@/icons/flex-flat/bicycle-bike.svg',
    'BootsIcon': '@/icons/flex-flat/boots.svg',
    'BrightnessIcon': '@/icons/flex-flat/brightness.svg',
    'CapFrontIcon': '@/icons/flex-flat/cap-front.svg',
    'CapSideIcon': '@/icons/flex-flat/cap-side.svg',
    'CricketIcon': '@/icons/flex-flat/cricket.svg',
    'CyclingIcon': '@/icons/flex-flat/cycling.svg',
    'DownhillSkiingIcon': '@/icons/flex-flat/downhill-skiing.svg',
    'DribbleLogoIcon': '@/icons/flex-flat/dribble-logo.svg',
    'FishingPhishingIcon': '@/icons/flex-flat/fishing-phishing.svg',
    'FlagScoreIcon': '@/icons/flex-flat/flag-score.svg',
    'FootballIcon': '@/icons/flex-flat/football.svg',
    'GolfIcon': '@/icons/flex-flat/golf.svg',
    'GymnasticsIcon': '@/icons/flex-flat/gymnastics.svg',
    'HangerIcon': '@/icons/flex-flat/hanger.svg',
    'HikingIcon': '@/icons/flex-flat/hiking.svg',
    'HockeyIcon': '@/icons/flex-flat/hockey.svg',
    'HolidayVacationBeachUmbrellaIcon': '@/icons/flex-flat/holiday-vacation-beach-umbrella.svg',
    'IceSkatingIcon': '@/icons/flex-flat/ice-skating.svg',
    'KayakingIcon': '@/icons/flex-flat/kayaking.svg',
    'LeafIcon': '@/icons/flex-flat/leaf.svg',
    'MartialArtsIcon': '@/icons/flex-flat/martial-arts.svg',
    'MeditationIcon': '@/icons/flex-flat/meditation.svg',
    'ModuleThreeIcon': '@/icons/flex-flat/module-three.svg',
    'MotorsportsHelmetIcon': '@/icons/flex-flat/motorsports-helmet.svg',
    'NordicWalkingIcon': '@/icons/flex-flat/nordic-walking.svg',
    'NotificationIcon': '@/icons/flex-flat/notification-icon.svg',
    'OrdersIcon': '@/icons/flex-flat/orders-icon.svg',
    'PaintPaletteIcon': '@/icons/flex-flat/paint-palette.svg',
    'PlaygroundIcon': '@/icons/flex-flat/playground.svg',
    'PottedFlowerTulipIcon': '@/icons/flex-flat/potted-flower-tulip.svg',
    'RollerSkatingIcon': '@/icons/flex-flat/roller-skating.svg',
    'RunningIcon': '@/icons/flex-flat/running.svg',
    'ScubaDivingIcon': '@/icons/flex-flat/scuba-diving.svg',
    'SettingsIcon': '@/icons/flex-flat/settings-icon.svg',
    'ShirtIcon': '@/icons/flex-flat/shirt.svg',
    'ShoppingBagHandBagIcon': '@/icons/flex-flat/shopping-bag-hand-bag.svg',
    'ShortsIcon': '@/icons/flex-flat/shorts.svg',
    'SkateboardingIcon': '@/icons/flex-flat/skateboarding.svg',
    'SleddingIcon': '@/icons/flex-flat/sledding.svg',
    'SnowFlakeIcon': '@/icons/flex-flat/snow-flake.svg',
    'SnowboardingIcon': '@/icons/flex-flat/snowboarding.svg',
    'SoccerIcon': '@/icons/flex-flat/soccer.svg',
    'SockIcon': '@/icons/flex-flat/sock.svg',
    'SprintIcon': '@/icons/flex-flat/sprint.svg',
    'StadiumIcon': '@/icons/flex-flat/stadium.svg',
    'SurfingIcon': '@/icons/flex-flat/surfing.svg',
    'SwimmingIcon': '@/icons/flex-flat/swimming.svg',
    'TennisIcon': '@/icons/flex-flat/tennis.svg',
    'UserCircleIcon': '@/icons/flex-flat/user-circle.svg',
    'VolleyballIcon': '@/icons/flex-flat/volleyball.svg',
    'WalkingStepsIcon': '@/icons/flex-flat/walking-steps.svg',
    'WhistleIcon': '@/icons/flex-flat/whistle.svg',
};